module.exports = __webpack_public_path__ + "media/images/logo-ff2a62b76c4c4f3fc7484f25632743bf.png";